import { ref } from 'vue';

const alertState = ref({
  visible: false,
  type: 'info',
  title: '',
  message: '',
  buttonText: 'OK',
  allowBackdropClose: true,
  resolve: null
});

const confirmState = ref({
  visible: false,
  type: 'warning',
  title: '',
  message: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  confirmVariant: 'primary',
  allowBackdropClose: true,
  resolve: null
});

export function usePopup() {
  const showAlert = (message, options = {}) => {
    return new Promise((resolve) => {
      alertState.value = {
        visible: true,
        type: options.type || 'info',
        title: options.title || '',
        message: message,
        buttonText: options.buttonText || 'OK',
        allowBackdropClose: options.allowBackdropClose !== false,
        resolve
      };
    });
  };

  const showConfirm = (message, options = {}) => {
    return new Promise((resolve) => {
      confirmState.value = {
        visible: true,
        type: options.type || 'warning',
        title: options.title || '',
        message: message,
        confirmText: options.confirmText || 'Confirm',
        cancelText: options.cancelText || 'Cancel',
        confirmVariant: options.confirmVariant || 'primary',
        allowBackdropClose: options.allowBackdropClose !== false,
        resolve
      };
    });
  };

  const closeAlert = () => {
    if (alertState.value.resolve) {
      alertState.value.resolve(true);
    }
    alertState.value.visible = false;
  };

  const closeConfirm = (confirmed) => {
    if (confirmState.value.resolve) {
      confirmState.value.resolve(confirmed);
    }
    confirmState.value.visible = false;
  };

  return {
    alertState,
    confirmState,
    showAlert,
    showConfirm,
    closeAlert,
    closeConfirm
  };
}

